/* eslint-env browser, node */
import React, { Component } from 'react';
import justNumbers from 'just-numbers';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { setVehicleWeight } from '../../redux/modules/registration';
import trim from '../../modules/trim';
import TextInput from '../../components/TextInput';

class VehicleWeightFee extends Component {
  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
    this.state = {
      error: false,
      errorMessage: '',
    };
  }

  handleInput(event) {
    const { vehicleWeightOrLengthLimit } = this.props;
    const value = trim(event.target.value);
    const numbers = Number(justNumbers(value));

    let error = false;
    let errorMessage = '';

    if (vehicleWeightOrLengthLimit && numbers < vehicleWeightOrLengthLimit.min) {
      error = true;
      errorMessage = `Vehicle Class Weight cannot be less than ${vehicleWeightOrLengthLimit.min}`;
    } else if (vehicleWeightOrLengthLimit && numbers > vehicleWeightOrLengthLimit.max) {
      error = true;
      errorMessage = `Vehicle Class Weight cannot exceed ${vehicleWeightOrLengthLimit.max}`;
    }
    this.setState({ error, errorMessage }, () => {
      this.props.setVehicleWeight(numbers);
    });
  }

  getWeightLimitText() {
    const { vehicleWeightOrLengthLimit, vehicleWeight } = this.props;
    const fieldClass = classNames({
      'Row-subtext': true,
      'no-print': true,
      'Row-subtext--error': this.state.error || !vehicleWeight || Number(vehicleWeight) === 0,
      'u-hidden': !this.state.error && vehicleWeight && Number(vehicleWeight) !== 0,
    });
    if (vehicleWeightOrLengthLimit) {
      return <span className={fieldClass}>Enter weight between <b>{vehicleWeightOrLengthLimit.min} - {vehicleWeightOrLengthLimit.max}</b></span>;
    }
  }
  render() {
    const { showVehicleWeightFee, vehicleWeight, vehicleWeightFee } = this.props;

    return (
      <div className="Row Registration-vehicleWeightFee" style={{ display: showVehicleWeightFee ? 'block' : 'none' }}>
        <TextInput tabIndex="-1" className="Row-total" id="vehicleWeightFeeTotal" tooltip="Total Fees applied to the vehicle's weight" value={vehicleWeightFee || '0.00'} readOnly />

        <input className="Row-input no-print" type="number" id="vehicleWeight" data-id="WeightList" value={vehicleWeight} onChange={this.handleInput} />
        <label className="Row-inputLabel no-print" htmlFor="vehicleWeight">Weight</label>{this.getWeightLimitText()}
        <b className="print-only">Weight: {vehicleWeight}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showVehicleWeightFee: state.registration.showVehicleWeightFee,
    vehicleWeight: state.registration.vehicleWeight,
    vehicleWeightFee: state.registration.vehicleWeightFee,
    vehicleWeightOrLengthLimit: state.registration.vehicleWeightOrLengthLimit,
  };
};

export default connect(mapStateToProps, { setVehicleWeight })(VehicleWeightFee);
